module.exports = __webpack_public_path__ + "img/one.3bafc111.png";